import React from 'react'
import HeroImg from '../../assets/images/company-formation/offshore-company-formation/hero-img.png'
import BannerImg from '../../assets/images/company-formation/offshore-company-formation/banner-img.png'
import BreadCrumbs from "../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../components/Constant/List/List";
import { TiTick } from "react-icons/ti";
import { GoDotFill } from "react-icons/go";
import Button from "../../components/Constant/button/Button";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../components/Constant/Testimonials/Testimonials";
import CTA from "../../components/Constant/cta/CTA";

const BreadCrumbsData = [
    {name: 'Offshore Advisory', link: '/'},
    {
        name: 'Offshore Company Formation',
        link: '/offshore-company-formation',
    },
]

function MauritiusCompanyFormation() {
    return (
        <main className='main'>
            <section className='section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='container'>
                    <h1 className='section-title'>Mauritius Company Formation</h1>
                    <br/>
                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>Incorporate in Africa’s Premier Financial & Offshore Hub</h3>
                            <p className='page-paragraph'>
                                A <b>Mauritius company</b> offers businesses and investors <b>tax planning advantages, treaty access, and international credibility.</b> With strong links to <b>India, Africa, and Asia,</b> Mauritius is a preferred jurisdiction for <b>investment holding, funds, and corporate structuring.</b>
                            </p>

                            <PageList
                                items={[
                                    {
                                        title: "Global Business Company (GBC)",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Authorised Company (AC)",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Strong Treaty Network",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Tax-Efficient",
                                        icon: TiTick,
                                    },
                                ]}
                            />
                            <Button
                                text="Request a Mauritius Company Formation Proposal →"
                                link="/consultation"
                                type="primary"
                                size="large"
                            />
                        </div>

                        <HeroRightImage src={HeroImg}/>
                    </div>
                    <BannerPageImg src={BannerImg}/>
                    <br/><br/>

                    <div className='flex-start'>
                        <h3 className='page-title'>
                            Why Incorporate in Mauritius?
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "International Credibility",
                                    paragraph: "Respected by banks, regulators, and investors",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Tax Efficiency",
                                    paragraph: "Effective tax rates as low as 3%",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Double-Tax Treaties",
                                    paragraph: "Agreements with 40+ countries",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Gateway to Africa & India",
                                    paragraph: "Widely used for investment structures",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Flexible Options",
                                    paragraph: "GBCs for regulated activity, ACs for offshore structuring",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Types of Companies in Mauritius
                        </h3>
                        <p className='page-subtitle'>1. Global Business Company (GBC)</p>
                        <PageList
                            items={[
                                { paragraph: "Licensed and regulated by the Financial Services Commission (FSC).", icon: GoDotFill },
                                { paragraph: "Subject to 3% effective corporate tax (with exemptions).", icon: GoDotFill },
                                { paragraph: "Used for investment funds, holding structures, and regulated activities.", icon: GoDotFill },
                                { paragraph: "Requires substance in Mauritius (local directors, accounting, office).", icon: GoDotFill },
                            ]}
                        />

                        <p className='page-subtitle'>2. Authorised Company (AC)</p>
                        <PageList
                            items={[
                                { paragraph: "Not considered a Mauritius tax resident.", icon: GoDotFill },
                                { paragraph: "No corporate tax in Mauritius.", icon: GoDotFill },
                                { paragraph: "Best for international trading, consulting, and asset protection.", icon: GoDotFill },
                                { paragraph: "No need for local directors.", icon: GoDotFill },
                            ]}
                        />

                        <h3 className='page-title'>Incorporation Requirements</h3>
                        <p className='page-subtitle'>For a GBC:</p>
                        <PageList
                            items={[
                                { paragraph: "At least 2 local directors.", icon: GoDotFill },
                                { paragraph: "Local registered office & management.", icon: GoDotFill },
                                { paragraph: "Annual audited financial statements.", icon: GoDotFill },
                                { paragraph: "Minimum capital requirement: none, but usually USD 1+.", icon: GoDotFill },
                            ]}
                        />

                        <p className='page-subtitle'>For an AC:</p>
                        <PageList
                            items={[
                                { paragraph: "1 director (can be foreign).", icon: GoDotFill },
                                { paragraph: "Local registered agent.", icon: GoDotFill },
                                { paragraph: "No audit required.", icon: GoDotFill },
                            ]}
                        />
                        <hr className='section-divider' />

                        <h3 className='section-title'>Benefits of Mauritius Companies</h3>
                        <PageList
                            items={[
                                {
                                    title: "Tax Planning",
                                    paragraph: "3% effective tax for GBCs, 0% for ACs",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Global Reputation",
                                    paragraph: "Stronger credibility than many offshore islands",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Banking Access",
                                    paragraph: "Eligible for both local and international banking",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Gateway to Africa/India",
                                    paragraph: "Ideal for structuring cross-border investments",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Flexible Options",
                                    paragraph: "Choose between regulated (GBC) or light-touch (AC) entities",
                                    icon: GoDotFill,
                                },
                            ]}
                        />
                        <hr className='section-divider' />

                        <h3 className='page-title'>Incorporation Process</h3>
                        <PageList
                            items={[
                                {
                                    title: "Consultation & Structure Selection",
                                    paragraph: "Choose between Global Business Company (GBC) or Authorised Company (AC).",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Name Reservation",
                                    paragraph: "Conducted with the Registrar of Companies to secure your company name.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Document Preparation",
                                    paragraph: "Drafting the Memorandum and Articles of Association and other incorporation documents.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Filing & Approval",
                                    paragraph: "Submission to the Financial Services Commission (FSC) for GBCs or Registrar for ACs.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Bank Account Opening",
                                    paragraph: "Assistance with local or international corporate bank accounts.",
                                    icon: GoDotFill,
                                },
                            ]}
                        />
                        <hr className='section-divider' />

                        <h3 className='page-title'>Timeline & Costs</h3>
                        <PageList
                            items={[
                                {
                                    title: "Timeline",
                                    paragraph: "2–3 weeks for GBC, 1 week for AC",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Setup Costs",
                                    paragraph: "From USD 4,000+ (AC) and USD 7,000+ (GBC)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Costs",
                                    paragraph: "FSC fees, accounting, registered office, compliance",
                                    icon: GoDotFill,
                                },
                            ]}
                        />
                        <hr className='section-divider' />

                        <h3 className='page-title'>
                            Common Uses of Mauritius Companies
                        </h3>
                        <PageList
                            items={[
                                {
                                    paragraph: "Investment Holding Company (especially for India & Africa)",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Fund Management Vehicle (regulated GBC)",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "International Trading Company",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Consulting & Advisory Firm",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Wealth Management & Asset Protection",
                                    icon: GoDotFill,
                                },
                            ]}
                        />
                        <hr className='section-divider' />

                        <h3 className='page-title'>Why Offshore Advisory?</h3>
                        <PageList
                            items={[
                                {
                                    title: "Specialists in Mauritius GBC & AC incorporation",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Strong network with licensed management companies & FSC regulators",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Expertise in fund structuring, fintech licensing, and tax planning",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Comparative insights",
                                    paragraph: "Mauritius vs Seychelles vs Malta vs Cyprus",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "End-to-end incorporation, compliance, and banking services",
                                    icon: GoDotFill,
                                },
                            ]}
                        />
                        <hr className='section-divider' />


                    </div>

                    <FAQList title='Frequently Asked Questions (FAQ)' data={faqData} />

                    <Testimonials title='Client Testimonials' testimonials={testimonialsData}/>

                    <CTA
                        title="Looking for a flexible, tax-efficient offshore structure?"
                        description="Mauritius offers both <b>regulated GBCs and unregulated ACs,</b> making it a strategic hub for Africa, India, and global investors."
                        buttonText="Book a Mauritius Company Formation Consultation →"
                        buttonLink="/consultation"
                    />
                </div>
            </section>
        </main>
    )
}

export default MauritiusCompanyFormation

const faqData = [
    {
        question: "What’s the difference between GBC and AC?",
        content: [
            { type: "answer", text: "GBC = regulated, 3% tax, used for funds & holding. AC = unregulated, 0% tax, used for trading/consulting." },
        ],
    },
    {
        question: "Do Mauritius companies need local directors?",
        content: [
            { type: "answer", text: "Yes for GBCs (2 local directors), no for ACs." },
        ],
    },
    {
        question: "Do Mauritius companies file audited accounts?",
        content: [
            { type: "answer", text: "Yes for GBCs, not for ACs." },
        ],
    },
    {
        question: "How long does incorporation take?",
        content: [
            { type: "answer", text: "1 week for AC, 2–3 weeks for GBC." },
        ],
    },
    {
        question: "Can foreigners own 100%?",
        content: [
            { type: "answer", text: "Yes — full foreign ownership is permitted." },
        ],
    },
];


const testimonialsData = [
    {
        quote:
            "We used a Mauritius GBC to structure investments into India. Offshore Advisory handled incorporation and FSC licensing.",
        author: "Rajesh P.",
        role: "Fund Manager",
    },
    {
        quote:
            "Our advisory firm incorporated as an AC. Offshore Advisory gave us tax neutrality and quick setup.",
        author: "Lisa M.",
        role: "Consultant",
    },
];